/* 同步的「本機狀態」：金鑰紀錄與連線設定存在哪裡、怎麼讀。
   刻意不含任何 React —— 這樣它可以在 Node 裡被測試，也讓 UI 只負責顯示。 */
import type { Repository } from "../data/repository.ts";
import type { KeyRecord, KeyMaterial } from "../crypto/keys.ts";

export interface SyncConfig { serverUrl: string; keyId: string }

const META_CONFIG = "sync.config";
const META_KEY_RECORD = "sync.keyRecord";

export async function loadSyncConfig(repo: Repository): Promise<SyncConfig | null> {
  const cfg = await repo.getMeta<SyncConfig>(META_CONFIG);
  if (!cfg || typeof cfg.serverUrl !== "string" || typeof cfg.keyId !== "string") return null;
  return cfg;
}

export async function saveSyncConfig(repo: Repository, cfg: SyncConfig): Promise<void> {
  await repo.setMeta(META_CONFIG, cfg);
}

/** 金鑰紀錄存在本機：沒有它，離線時連解鎖都做不到。 */
export async function loadKeyRecord(repo: Repository): Promise<KeyRecord | null> {
  const rec = await repo.getMeta<KeyRecord>(META_KEY_RECORD);
  return rec && rec.version === 1 ? rec : null;
}

export async function saveKeyRecord(repo: Repository, record: KeyRecord): Promise<void> {
  await repo.setMeta(META_KEY_RECORD, record);
}

/** 這台裝置上的金鑰只留在記憶體：重新載入頁面就要重新解鎖（金鑰不落地）。 */
export interface UnlockedSession {
  keyId: string;
  material: KeyMaterial;
  authKeyB64: string;
}

export function validatePassphrase(passphrase: string, confirm?: string): { ok: true } | { ok: false; key: string } {
  if (passphrase.length < 12) return { ok: false, key: "sync.passphrase.tooShort" };
  if (confirm !== undefined && passphrase !== confirm) return { ok: false, key: "sync.passphrase.mismatch" };
  return { ok: true };
}

export function normalizeServerUrl(input: string): string {
  const trimmed = input.trim().replace(/\/+$/, "");
  if (!trimmed) return "";
  return /^https?:\/\//i.test(trimmed) ? trimmed : "https://" + trimmed;
}
